import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Theme } from '../../theme/theme';
import { AppDrawer } from './drawer.container';
import { Courses } from '../../courses/components/courses.container';
import { Students } from '../../students/components/students.container';
import { Events } from '../../events/components/events.component';
import { Polls } from '../../polls/components/polls.component';
import { News } from '../../news/components/news.component';
import { FeedItemWizard } from '../../feed/components/feed-item-wizard.component';
import { Approvals } from '../../approvals/components/approvals.component';
import { SettingsPage } from '../../settings/components/settings-page.rn';
import { DashboardContainer } from '../../dashboard/components/dashboard.container';
import { Helpdesk } from '../../helpdesk/components/helpdesk.container';
import { HelpdeskChat } from '../../helpdesk/components/helpdesk-chat-screen.container';
import { HelpdeskNewChat } from '../../helpdesk/components/helpdeks-new-chat.container';
import { PublishNotification } from '../../notifications/components/publish-notification.container';
import { SportsEvents } from '../../sports-events/components/sports-events.component';
import { Manuals } from '../../manuals/components/manuals.container';
import { Videos } from '../../videos/components/videos.container';

export class MainView extends Component {
  render() {
    return (
      <div className="min-h-screen w-full" style={{ backgroundColor: Theme.BG_COLOR }}>
        <AppDrawer />
        <div className="min-h-screen pl-64">
          <Routes>
            <Route path="notifications" element={<PublishNotification />} />
            <Route path="helpdesk" element={<Helpdesk />} />
            <Route path="helpdesk-new" element={<HelpdeskNewChat />} />
            <Route path="helpdesk/:id" element={<HelpdeskChat />} />
            <Route path="dashboard" element={<DashboardContainer />} />
            <Route path="courses" element={<Courses />} />
            <Route path="students" element={<Students />} />
            <Route path="events" element={<Events />} />
            <Route path="sports-events" element={<SportsEvents />} />
            <Route path="polls" element={<Polls />} />
            <Route path="news" element={<News />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="manuals" element={<Manuals />} />
            <Route path="videos" element={<Videos />} />
            <Route path="events/create" element={<FeedItemWizard />} />
            <Route path="events/edit/:id" element={<FeedItemWizard />} />
            <Route path="events/publish/:id" element={<FeedItemWizard />} />
            <Route path="events/platforms/:id" element={<FeedItemWizard />} />
            <Route path="sports-events/create" element={<FeedItemWizard />} />
            <Route path="sports-events/edit/:id" element={<FeedItemWizard />} />
            <Route path="sports-events/publish/:id" element={<FeedItemWizard />} />
            <Route path="sports-events/platforms/:id" element={<FeedItemWizard />} />
            <Route path="news/create" element={<FeedItemWizard />} />
            <Route path="news/edit/:id" element={<FeedItemWizard />} />
            <Route path="news/publish/:id" element={<FeedItemWizard />} />
            <Route path="news/platforms/:id" element={<FeedItemWizard />} />
            <Route path="polls/create" element={<FeedItemWizard />} />
            <Route path="polls/edit/:id" element={<FeedItemWizard />} />
            <Route path="polls/publish/:id" element={<FeedItemWizard />} />
            <Route path="polls/platforms/:id" element={<FeedItemWizard />} />
          </Routes>
        </div>
      </div>
    );
  }
}
